<template lang="pug">
div.loyalty-template-main
  h1.loyalty-template-main__title {{ $t('loyalty.mainData') }}
  h2.loyalty-template-main__subtitle {{ $t('loyalty.program') }}
  span.loyalty-template-main__data {{ descripcionPrograma }}
  div.loyalty-template-main__espaciado
  h2.loyalty-template-main__subtitle {{ $t('loyalty.templateTitle') }}
  span.loyalty-template-main__data {{ data.descripcion || $t('loyalty.noData') }}
  div.loyalty-template-main__espaciado
  h2.loyalty-template-main__subtitle {{ $t('loyalty.subtitle') }}
  span.loyalty-template-main__data {{ data.subtitulo || $t('loyalty.noData') }}
  div.loyalty-template-main__espaciado
  h2.loyalty-template-main__subtitle {{ $t('loyalty.periodValidity') }}
  span(v-if="data.fechaici.valueDate && data.fechafin.valueDate").loyalty-template-main__data {{ $t('loyalty.since') }} {{ data.fechaici | formatDateLocale }} {{ $t('loyalty.until') }} {{ data.fechafin | formatDateLocale }}
  span(v-else).loyalty-template-main__data {{ $t('loyalty.noData') }}
</template>
<script>
export default {
  props: {
    data: {
      type: Object
    }
  },
  name: 'DatosPlantilla',

  data () {
    return {
      descripcionPrograma: sessionStorage.getItem('appProgramDescr')
    }
  }
}
</script>
<style lang="scss">
.loyalty-template-main{
  .ods-module__body{
    padding: 0;
  }
  &__espaciado{
  padding-bottom: rem(24);
  }
  &__data{
   padding-left: rem(32);
   font-size: rem(12);
   line-height: rem(24);
  }
    &__title{
    font-size: rem(14);
    line-height: rem(24);
    margin-bottom: rem(16);
    margin-left: rem(32);
    margin-top: rem(32);
    font-weight: 500;
  }

  &__subtitle{
    font-size: rem(9);
    line-height: rem(16);
    margin-bottom: rem(8);
    text-transform: uppercase;
    color: #6E767D;
    font-weight: 400;
    margin-left: rem(32);
  }
}
</style>
